import { CLIENT_ENUM_TO_TYPES_MAP } from '../../shared/constants'

export const normalizeStatus = value => {
  const status = value ? 'DELETED' : 'ACTIVE'
  return CLIENT_ENUM_TO_TYPES_MAP[status]
}



// WEBPACK FOOTER //
// ./src/Containers/Clients/utils.js